export default __webpack_public_path__ + "static/media/crm_active.8b02f6f0.svg";